'use strict';

module.exports = [
  '$modal',
  '$scope',
  '$miscUtils',
  'PersonDomain',
  '$toast',
  'profile',
  'organization',
  PersonnelCreateController];

// TODO: add avatar upload support
function PersonnelCreateController($modal, $scope, $miscUtils, PersonDomain, $toast, existingProfile, organization) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/

  const vm = $scope.profileCreate = initViewModel(this, existingProfile);
  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = !existingProfile ?
    $modal.cancel.bind($modal) :
    function revertDataAndClose() {
      vm.model.$revert();
      return $modal.cancel();
    };


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    if (!vm.model.$validate()) {
      return Promise.reject(vm.model.$errors);
    } else {
      return (existingProfile ? vm.model.update() : vm.model.create())
        .then(function () {
          if (!existingProfile) {
            $toast.showI18nMessage({
              messageId: 'profile.create.contact.success.message',
              messageParams: {name: vm.model.name},
              type: 'info',
            });
          }
          return $modal.hide(vm.model);
        }, function (error) {
          console.error(error);
        });// TODO: show errors in view
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/


  function initViewModel(vm, person) {
    if (person) {
      vm.model = person;
    } else {
      vm.model = PersonDomain.$factory.create();
      vm.model.organization = organization;
    }

    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/PersonnelCreateController.js